
import React, { useState } from 'react';
import CreatePurchaseOrderForm from '../components/PurchaseOrderForm'; // Renamed import
import PurchaseOrderSearchForm from '../components/PurchaseOrderSearchForm'; // New import

const TABS = {
  CREATE: 'create',
  SEARCH: 'search',
};

const Purchase = () => {
  const [activeTab, setActiveTab] = useState(TABS.CREATE);

  const tabClass = (tabName) => 
    `py-2 px-4 font-semibold text-sm focus:outline-none transition-colors ${
      activeTab === tabName
        ? 'border-b-4 border-indigo-600 text-indigo-700 bg-indigo-50'
        : 'text-gray-500 hover:text-gray-700'
    }`;

  return (
    <div className="max-w-4xl mx-auto mt-8">
      {/* Tab Navigation */}
      <div className="flex border-b border-gray-200 mb-6">
        <button 
          onClick={() => setActiveTab(TABS.CREATE)} 
          className={tabClass(TABS.CREATE)}
        >
          ➕ Create Purchase Order
        </button>
        <button 
          onClick={() => setActiveTab(TABS.SEARCH)} 
          className={tabClass(TABS.SEARCH)}
        >
          🔍 Search Order History
        </button>
      </div>

      {/* Tab Content */}
      <div className="bg-white shadow-xl rounded-lg p-6">
        {activeTab === TABS.CREATE && <CreatePurchaseOrderForm />}
        {activeTab === TABS.SEARCH && <PurchaseOrderSearchForm />}
      </div>
    </div>
  );
};

// export default PurchaseOrderPage;
// import React from 'react';
// import PurchaseOrderForm from '../components/PurchaseOrderForm';
// // 1. Import the component (assuming PurchaseOrderForm.jsx is in the same directory)

// const Purchase = () => {
//   return (
//     <div className="p-4 sm:p-6 lg:p-8 bg-gray-100 min-h-screen">
//       <h1 className="text-4xl font-extrabold text-gray-900 mb-8">
//         New Purchase
//       </h1>
      
//       {/* 2. Embed the PurchaseOrderForm component here */}
//       <PurchaseOrderForm/>
      
//     </div>
//   );
// };

export default Purchase;